/**
 * Main Layout Component
 *
 * Provides:
 * - Responsive layout (Desktop: Sidebar | Mobile: Bottom Tabs)
 * - Navigation structure
 * - Protected route wrapper
 */

import { type ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps): JSX.Element {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className="layout">
      {!isMobile && <Sidebar />}

      <main className="layout__content">
        {children}
      </main>

      {isMobile && <BottomNav />}
    </div>
  );
}
